import { render, staticRenderFns } from "./check-password.vue?vue&type=template&id=1213ff8a"
import script from "./check-password.vue?vue&type=script&lang=js"
export * from "./check-password.vue?vue&type=script&lang=js"
import style0 from "./check-password.vue?vue&type=style&index=0&id=1213ff8a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports